import React from 'react';

const reportSubscribeConversion = () => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'conversion', {
    send_to: 'AW-16522909255/NNQBCIvb-qQcEMes3sY9',
    transaction_id: '',
  });
};

export const BuyButton = ({ userEmail }) => {
  return (
    <div onClick={reportSubscribeConversion}>
      <stripe-buy-button
        buy-button-id={process.env.REACT_APP_STRIPE_BUY_BUTTON_ID}
        publishable-key={process.env.REACT_APP_STRIPE_PK}
        customer-email={userEmail}
      >
      </stripe-buy-button>
    </div>
  );
}

